import * as React from "react"
import { TextField, type TextFieldProps } from "./TextField.tsx"

export const UrlField = ({ onChange, onBlur, defaultValue, ...props }: Omit<TextFieldProps, "type">) => {
  const [value, setValue] = React.useState(defaultValue ?? "")

  return (
    <TextField
      type="text"
      value={value}
      onBlur={(e) => {
        setValue(formatUrl(e.target.value))
        onBlur?.(e)
      }}
      onChange={(e) => {
        setValue(e.target.value)
        onChange?.(e)
      }}
      {...props}
    />
  )
}

export const formatUrl = (value: string) => {
  if (!value) return ""

  if (value.startsWith("http://")) return value.replace("http://", "https://")

  return value.startsWith("https://") ? value : `https://${value}`
}
